<template>
	<div id="app">
	  <transition name="slide-left">
		<router-view></router-view>
	  </transition>
	  
	</div>
  </template>
  <script>
  import { deprecationHandler } from "moment";
  import { mapState } from "vuex";
  
  export default {
	name: "App",
	data() {
	  return {};
	},
	computed: {
	  //引入值
	  ...mapState({
		msg: (state) => state.signalr.msg,
		token: (state) => state.userInfo.token,
	  }),
	//   页面有token就连接连接  页面刷新触发销毁函数就断开连接
	//   token() {
	//   	const token = this.$store.userInfo ? this.$store.userInfo.token : null
	//   	return token
	//   },
	},
	mounted() {
	  if (this.token) {
		//当token发生变化就重新连接ws
		this.$store.dispatch("signalr/startInitSignalR");
	  }
	},
	methods: {
	  // 消息
	  open2() {
		const msg = this.msg.content;
		  this.$notify({
		  title: "新消息来了",
		  message: msg,
		  dangerouslyUseHTMLString: true,
		  duration: 0,
		});
	    
	  },
	},
	watch: {
	  msg() {
		if(this.msg.content){
			this.open2();
		}
	  },
	  token(newvalue, oldvalue) {
		if (this.token) {
		  //当token发生变化就重新连接
		  this.$store.dispatch("signalr/startInitSignalR");
		}
	  },
	},
	beforeDestroy() {
	  //当浏览器关闭或者销毁就断开连接
	  this.$store.dispatch("signalr/disconnectSignalR");
	},
  };
  </script>
  
  <style lang="scss">
  #app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background-color: #fbfbfb;
	width: 100%;
	height: 100%;
  }
  
  /* 自定义部分 */
  // input
  .el-input {
	.el-input__inner:focus {
	  border-color: $mainColor;
	}
  }
  
  // textarea
  .el-textarea {
	.el-textarea__inner:focus {
	  border-color: $mainColor;
	}
  }
  
  // button
  .el-button {
	&.el-button--warning {
	  background-color: $mainColor;
	  border-color: $mainColor;
  
	  &:hover {
		background-color: $mainColor;
		border-color: $mainColor;
	  }
  
	  &:focus {
		background-color: $mainColor;
		border-color: $mainColor;
	  }
  
	  &.is-plain {
		background-color: $tableTitBg;
		border-color: $mainColor;
		color: $mainColor;
  
		&:hover {
		  background: $mainColor;
		}
  
		&:focus {
		  background: $mainColor;
		}
	  }
	}
  
	&.el-button--text {
	  color: $mainColor;
  
	  &:focus {
		color: $mainColor;
	  }
  
	  &:hover {
		color: $mainColor;
	  }
	}
  
	&.el-button--default {
	  &:focus {
		color: $mainColor;
		border-color: $mainColor;
		background-color: transparent;
	  }
  
	  &:hover {
		color: $mainColor;
		border-color: $mainColor;
		background-color: transparent;
	  }
	}
  }
  
  // pagination
  .paging {
	.el-pagination.is-background .el-pager li:not(.disabled) {
	  &.active {
		background-color: $mainColor;
  
		&:hover {
		  color: #fff;
		}
	  }
  
	  &:hover {
		color: $mainColor;
	  }
	}
  }
  
  // radio
  .el-radio {
	.el-radio__input {
	  &.is-focus {
		.el-radio__inner {
		  border-color: $mainColor;
  
		  &:hover {
			border-color: $mainColor;
		  }
		}
	  }
  
	  &.is-checked {
		.el-radio__inner {
		  background-color: $mainColor;
		  border-color: $mainColor;
		}
	  }
  
	  &.is-indeterminate {
	  }
  
	  &.is-checked + .el-radio__label {
		color: $mainColor;
	  }
  
	  .el-radio__inner {
		&:hover {
		  border-color: $mainColor;
		}
	  }
	}
  
	.el-radio__label {
	  color: $fontColor;
	}
  }
  
  .el-radio-group {
	.el-radio-button {
	  .el-radio-button__orig-radio {
		&:checked + .el-radio-button__inner {
		  background-color: $mainColor;
		  border-color: $mainColor;
		  box-shadow: -1px 0 0 0 $mainColor;
		}
	  }
  
	  .el-radio-button__inner {
		&:hover {
		  color: $mainColor;
		}
	  }
	}
  }
  
  // checkBox
  .el-checkbox {
	.el-checkbox__input {
	  &.is-focus {
		.el-checkbox__inner {
		  border-color: $mainColor;
  
		  &:hover {
			border-color: $mainColor;
		  }
		}
	  }
  
	  &.is-indeterminate {
		.el-checkbox__inner {
		  border-color: $mainColor;
		  background-color: $mainColor;
  
		  &:hover {
			border-color: $mainColor;
		  }
		}
	  }
  
	  &.is-checked {
		.el-checkbox__inner {
		  background-color: $mainColor;
		  border-color: $mainColor;
		}
	  }
  
	  &.is-checked + .el-checkbox__label {
		color: $mainColor;
	  }
  
	  &.is-indeterminate {
	  }
  
	  .el-checkbox__inner {
		&:hover {
		  border-color: $mainColor;
		}
	  }
	}
  }
  
  // table
  .el-table {
	tr {
	  th {
		background-color: $tableTitBg;
		font-size: 12px;
	  }
  
	  td {
		font-size: 12px;
	  }
	}
  
	&.el-table--enable-row-hover {
	  .el-table__body {
		tr {
		  &:hover {
			td {
			  background-color: $tableRowHoverBackgroundColor;
			}
		  }
		}
	  }
	}
  }
  
  // select
  .el-select {
	.el-input {
	  &.is-focus.el-input--suffix {
		.el-input__inner {
		  border-color: $mainColor;
  
		  &:focus {
			border-color: $mainColor;
		  }
		}
	  }
  
	  .el-input__inner {
		&:focus {
		  border-color: $mainColor;
		}
	  }
	}
  }
  
  // date 时间选择插件
  .el-range-editor.el-input__inner {
	&.is-active {
	  border-color: $mainColor;
  
	  &:hover {
		border-color: $mainColor;
	  }
	}
  }
  
  // tag
  span.el-tag {
	&.el-tag--warning {
	  background-color: $tableTitBg;
	  border-color: $mainColor;
	  color: $mainColor;
	}
  }
  </style>
  